export class CalculadoraDeValorMedio {
  static calcularEmUPF(valorMedioTotal: number, taxaUPF: number) {
    return valorMedioTotal / taxaUPF
  }
}
